import script from "./VehicleRegistrationListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleRegistrationListComponent.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleRegistrationListComponent.vue?vue&type=style&index=0&id=6a833bca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a833bca"]])

export default __exports__